import BaseComponent from "../../../baseComponent.js";
import TreeMapWidget from "../../widgets/treeMap/treeMapWidget.jsx";

export default class TreeMap extends BaseComponent {
  constructor(props) {
    super(props);
  }
  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    return (
      <TreeMapWidget widgetId={this.props.model.id}
                 components={this.props.components}
                 legends={this.props.model.legends}
                     togglePreloader={() => true}
                 componentId={component.controller.id}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/treeMap.jsx